import React from 'react';

class PrintPageClass extends React.Component {
   state = {};

   render() {
      const { ref } = this.props;

      return (
         <div ref={ref} className='print'>
            <div className='header'>HEADER</div>
            <div className='body'>{this.props.body}</div>
            <div className='footer'>FOOTER</div>
         </div>
      );
   }
}

export default React.forwardRef((props, ref) => (
   <PrintPageClass ref={ref} {...props} />
));
